import utils from '~/utils'

export default ({ app, $config }, inject) => {
  // 给utils this添加$config，并将其注入 Vue, context 和 store.
  utils.$config = $config;
  inject('utils', utils);
}